import { render, staticRenderFns } from "./Sketch.vue?vue&type=template&id=4aed9134"
import script from "./Sketch.vue?vue&type=script&lang=js"
export * from "./Sketch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports